import styled from "styled-components/macro";
const ComponentWrapper = styled("p")`
  color: red;
  margin: 0.5rem 0 !important;
` as any;

export { ComponentWrapper };
